/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignsShow } from '../../axios/campaignsShow'
import type { CampaignsShowError, CampaignsShowPathParams, CampaignsShowResponse } from '../../types/CampaignsShow'

export const campaignsShowQueryKey = (campaign: CampaignsShowPathParams['campaign']) =>
	[{ url: '/campaigns/:campaign', params: { campaign } }] as const

export type CampaignsShowQueryKey = ReturnType<typeof campaignsShowQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::show */
export function campaignsShowQueryOptions(campaign: CampaignsShowPathParams['campaign'], config?: AxiosRequestConfig) {
	return queryOptions<
		CampaignsShowResponse,
		AxiosError<CampaignsShowError>,
		CampaignsShowResponse,
		CampaignsShowQueryKey
	>({
		queryKey: campaignsShowQueryKey(campaign),
		queryFn: ({ signal }) => campaignsShow(campaign, { signal, ...config }).then(res => res.data),
		enabled: !!campaign,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::show */
export function useCampaignsShow<TSelectData = CampaignsShowResponse>(
	campaign: CampaignsShowPathParams['campaign'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CampaignsShowResponse,
					AxiosError<CampaignsShowError>,
					TSelectData,
					CampaignsShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CampaignsShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...campaignsShowQueryOptions(campaign),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::show */
export function useCampaignsShowSuspense<TSelectData = CampaignsShowResponse>(
	campaign: CampaignsShowPathParams['campaign'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CampaignsShowResponse,
					AxiosError<CampaignsShowError>,
					TSelectData,
					CampaignsShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CampaignsShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...campaignsShowQueryOptions(campaign),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
